import { SUCCESS_CUSTOMERS } from './actionTypes';

const initialState = {
    list: [],
    total: 0
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_CUSTOMERS:
            return {
                ...state,
                list: action.payload.items,
                total: action.payload.total_count
            }
        default:
            return state;
    }
}